import React, { useState, useEffect } from "react";
import CardRubriques from "./components/CardRubriques";
import rubriqueService from "../../../service/rubriques.service";
import Swal from "sweetalert2";
import { motion } from "framer-motion";

const Rubriques = () => {
  const [rubriques, setRubriques] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRubriques = async () => {
    setLoading(true);
    try {
      const data = await rubriqueService.getAll();
      setRubriques(data);
      setError(null);
    } catch (error) {
      console.error("Erreur lors de la récupération des rubriques:", error);
      setError(
        "Impossible de charger les rubriques. Veuillez réessayer plus tard."
      );

      // Notification d'erreur
      Swal.fire({
        icon: "error",
        title: "Erreur de chargement",
        text: "Impossible de charger les rubriques. Veuillez réessayer plus tard.",
        confirmButtonColor: "#d33",
        customClass: {
          popup: "rounded-xl",
          title: "text-xl font-bold text-red-600",
          confirmButton: "rounded-lg font-medium",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRubriques().then((r) => console.log(r));
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="mt-5 flex h-full"
    >
      {loading ? (
        <div className="flex w-full flex-col items-center justify-center py-16">
          <div className="relative h-20 w-20">
            <div className="absolute left-0 top-0 h-20 w-20 rounded-full border-4 border-[#57A863] border-opacity-20"></div>
            <div className="border-transparent absolute left-0 top-0 h-20 w-20 animate-spin rounded-full border-4 border-t-[#57A863]"></div>
          </div>
          <p className="mt-6 text-lg font-medium text-gray-700">
            Chargement des rubriques...
          </p>
        </div>
      ) : error ? (
        <div className="w-full rounded-lg bg-red-50 p-6 text-center text-red-600">
          <svg
            className="mx-auto mb-4 h-12 w-12 text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <h3 className="mb-2 text-lg font-medium">Erreur de chargement</h3>
          <p>{error}</p>
          <button
            onClick={fetchRubriques}
            className="mt-4 rounded-lg bg-red-600 px-5 py-2 text-white hover:bg-red-700"
          >
            Réessayer
          </button>
        </div>
      ) : (
        <CardRubriques rubriques={rubriques} setRubriques={setRubriques} />
      )}
    </motion.div>
  );
};

export default Rubriques;
